import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure
} from '@chakra-ui/react';

const SpeedDetails = ({ speed, className }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (!speed?.speed_details?.trim()) return null;

  const handleOfferDetails = (details) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = details;
    details = txt.value;
    return details.replaceAll(/\r/g, '').replaceAll(/\n/g, '<br>');
  };

  // Simple responsive modal size detection
  let modalSize = 'xl';
  let modalMargin = '0.5rem';
  if (typeof window !== 'undefined' && window.matchMedia("(max-width: 540px)").matches) {
    modalSize = 'full';
    modalMargin = '0';
  }

  return (
    <>
      <p className={className} onClick={onOpen}>*View Offer Details</p>
      <Modal isOpen={isOpen} onClose={onClose} size={modalSize} scrollBehavior="outside">
        <ModalOverlay />
        <ModalContent marginTop={modalMargin} marginBottom={modalMargin}>
          <ModalHeader paddingBottom="0">Offer Details</ModalHeader>
          <ModalCloseButton size="sm" color="gray" marginTop="3" marginRight="2.5" />
          <ModalBody paddingBottom="4">
            <div
              className="text-gray-600 text-sm"
              dangerouslySetInnerHTML={{ __html: handleOfferDetails(speed.speed_details) }}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default SpeedDetails;
